import React, { useEffect, useState } from 'react';
import { X, ArrowRight, AlertCircle } from 'lucide-react';

interface BackWarningModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export default function BackWarningModal({ isOpen, onConfirm, onClose }: BackWarningModalProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => setIsVisible(true), 50);
    } else {
      setIsVisible(false);
    }
  }, [isOpen]);

  const handleConfirm = () => {
    setIsVisible(false);
    setTimeout(() => {
      onConfirm();
    }, 300);
  };

  if (!isOpen) return null;

  return (
    <>
      <div
        className={`fixed inset-0 bg-black/40 backdrop-blur-sm z-[9998] transition-opacity duration-300 ${
          isVisible ? 'opacity-100' : 'opacity-0'
        }`}
        onClick={handleConfirm}
      />

      <div
        className={`fixed inset-x-0 bottom-0 z-[9999] transition-all duration-500 ease-out ${
          isVisible ? 'translate-y-0' : 'translate-y-full'
        }`}
        style={{
          paddingBottom: 'max(20px, env(safe-area-inset-bottom))',
        }}
      >
        <div className="bg-white rounded-t-[28px] shadow-2xl overflow-hidden mx-4">
          <div className="flex justify-center pt-3 pb-2">
            <div className="w-10 h-1 bg-gray-300 rounded-full" />
          </div>

          <div className="px-6 pb-6 pt-2">
            <div className="flex items-center justify-center mb-6">
              <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-orange-600 rounded-full flex items-center justify-center shadow-lg">
                <AlertCircle className="w-8 h-8 text-white" />
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 text-center mb-3">
              מומלץ להשלים את ההרשמה
            </h2>

            <p className="text-gray-600 text-center text-base leading-relaxed mb-8">
              כדי לנצל את כל היכולות של המערכת, מומלץ להשלים את כל שלבי ההרשמה לפני החזרה.
            </p>

            <div className="space-y-3">
              <button
                onClick={handleConfirm}
                className="w-full bg-gradient-to-l from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white py-4 px-6 rounded-2xl font-semibold text-lg shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center gap-3 active:scale-[0.98]"
              >
                <span>חזור בכל זאת</span>
                <ArrowRight className="w-5 h-5" />
              </button>

              <button
                onClick={onClose}
                className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 py-4 px-6 rounded-2xl font-semibold text-lg transition-all duration-200 active:scale-[0.98]"
              >
                המשך בהרשמה
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
